// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1PharmacyBiResultSearchDefaultResponse {
    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiResultSearchDefaultResponse.attributeTypeMap;
    }
}
PharmacyV1PharmacyBiResultSearchDefaultResponse.discriminator = undefined;
PharmacyV1PharmacyBiResultSearchDefaultResponse.additionalProperties = false;
PharmacyV1PharmacyBiResultSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacyV1PharmacyBiResultSearchDefaultResponseData"
    },
];
//# sourceMappingURL=pharmacyV1PharmacyBiResultSearchDefaultResponse.js.map